export enum PageEmotesActionTypes {
  FETCH_PAGE_EMOTES_LOADING = 'FETCH_PAGE_EMOTES_LOADING',
  FETCH_PAGE_EMOTES_ERROR = 'FETCH_PAGE_EMOTES_ERROR',
  FETCH_PAGE_EMOTES_SUCCESS = 'FETCH_PAGE_EMOTES_SUCCESS',
  PLAY_PAGE_EMOTES_ERROR = 'PLAY_PAGE_EMOTES_ERROR',
  PLAY_PAGE_EMOTES_SUCCESS = 'PLAY_PAGE_EMOTES_SUCCESS',
  PAGE_EMOTES_FILTERED = 'PAGE_EMOTES_FILTERED',
}
